import { getBackgroundImageOptions } from "@circle-react-shared/BuilderUI/utils/backgroundHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import type { DefaultBlockStyles } from "../Homepage/constants";

export const aboutUsPrimaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-primary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const aboutUsSecondaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor: "var(--theme-website-color-background-secondary)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const aboutUsTertiaryBlockDefaultStyles: DefaultBlockStyles = {
  backgroundColor:
    "var(--theme-website-primary-button-default-background-color)",
  padding: {
    paddingTop: "112",
    paddingBottom: "112",
    paddingLeft: "56",
    paddingRight: "56",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
};

export const getAboutUsBlockPrimaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: aboutUsPrimaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: aboutUsPrimaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: aboutUsPrimaryBlockDefaultStyles.margin,
  }),
});

export const getAboutUsBlockSecondaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: aboutUsSecondaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: aboutUsSecondaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: aboutUsSecondaryBlockDefaultStyles.margin,
  }),
});

export const getAboutUsBlockTertiaryStyleOptions = () => ({
  backgroundColor: getBackgroundColorOptions({
    defaultValue: aboutUsTertiaryBlockDefaultStyles.backgroundColor,
  }),
  backgroundImage: getBackgroundImageOptions(),
  padding: getPaddingOptions({
    defaultValue: aboutUsTertiaryBlockDefaultStyles.padding,
  }),
  margin: getMarginOptions({
    defaultValue: aboutUsTertiaryBlockDefaultStyles.margin,
  }),
});
